import React, { useMemo } from 'react';
import sum from 'lodash/sum';

import { LocalItem, LocalVariation } from '~Types';
import { useEntryFinder } from '~Components/EntryFinder';
import Details from '../Scenes/Details';
import useItemModifications from '~Hooks/ItemModifications/useItemModifications';

export type Order = {
  item: LocalItem;
  selectedVariations: LocalVariation[];
  removedVariations: LocalVariation[];
  quantity: number;
  price: number;
};
interface Props {
  cartItemsQuantity: number;
  hideBottomButtons: boolean;
  item: LocalItem;
  editItem: LocalItem;
  onEditOrder: (
    id: string,
    variations: LocalVariation[],
    removedVariations: LocalVariation[],
  ) => void;
}
const EditItem = ({
  cartItemsQuantity,
  hideBottomButtons,
  item,
  editItem,
  onEditOrder,
}: Props) => {
  const findEntryFromItem = useEntryFinder();
  const itemModifications = useItemModifications(item.modificationGroups || []);

  const entry = findEntryFromItem(item.id);
  const price = useMemo(
    () => sum([entry?.price, ...itemModifications.selectedVariations.map((sv) => sv.price)]),
    [entry, itemModifications.selectedVariations],
  );

  const onComplete = () => {
    onEditOrder(
      editItem.id,
      itemModifications.selectedVariations,
      itemModifications.removedVariations,
    );
  };

  return (
    <Details
      isEdit
      cartItemsQuantity={cartItemsQuantity}
      modificationGroups={itemModifications.modificationGroups}
      onSelectVariation={itemModifications.onSelectVariation}
      quantity={1}
      item={item}
      price={price}
      onSubmit={onComplete}
      hideBottomButtons={hideBottomButtons}
    />
  );
};

export default EditItem;
